module.exports = __webpack_public_path__ + "static/media/webiste-image-2.bf3d751a.png";